import React from 'react';
import { observer } from 'mobx-react';
import { NotificationsIcon } from '@seedlang/icons';
import { AppUI } from '@seedlang/state';
import NotificationIndex from 'components/notification/notification_index';
import NotificationIndexMemrev from 'components/notification/notification_index_memrev';
import Spinner from 'components/spinner';
import styled from '@emotion/styled';
import Text from 'components/text';
import HeaderPopup from 'components/header_popup';
import isBlank from 'is-blank';
import { Theme } from '@seedlang/constants/src';
import { computed } from 'mobx';
import eventParamsHelper from 'utils/event_params_helper';

const Wrapper = styled.div`
  .notifications-icon {
    border-radius: 50%;
    height: 42px;
    width: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    .icon-wrapper {
      width: 17px;
      height: 20px;
      .bell-icon {
        width: 18px;
        pointer-events: none;
      }
      svg {
        width: 17px;
        fill: #333;
      }
    }
  }
`;

const ScrollContainer = styled.div`
  position: relative;
  overflow: auto;
  height: ${props => props.isMobile ? 'calc(100dvh - 50px)' : 'calc(100% - 46px)'};
`;

@observer
class NotificationsWithPopup extends React.Component {
  onClickIcon = () => {
    if (!AppUI.notificationsOpened && AppUI.siteIsMemrev) {
      AppUI.createEvent('memrev - view notifications', eventParamsHelper());
    }
    AppUI.toggleNotificationsOpened();
  }

  @computed get height() {
    if (AppUI.siteIsMemrev) {
      return null;
    }
    return AppUI.layout.isMobile ? AppUI.layout.mobileContentHeight : 400;
  }

  render() {
    return (
      <Wrapper>
        <HeaderPopup
          title='Notifications'
          height={this.height}
          width={AppUI.layout.isMobile ? '100%' : '400px'}
          arrowRight={AppUI.layout.isMobile ? 68 : 56}
          right='-50px'
          background={this.props.background}
          onClickIcon={this.onClickIcon}
          popupOpened={AppUI.notificationsOpened}
          icon={
            <NotificationsIcon
              count={AppUI.user.unseenNotificationsCount}
              hoverColor={this.props.hoverColor}
              hoverBackground={this.props.hoverBackground}
            />
          }
        >
          <ScrollContainer
            isMobile={AppUI.layout.isMobile}
          >
            {
              AppUI.user.notificationsCount === 0 &&
                <Text
                  center
                  bold
                  padding='20px'
                  fontSize='14px'
                >
                  You have no notifications
                </Text>
            }
            {
              AppUI.user.notificationsCount > 0 && !AppUI.notificationStore.initialRequestReceived &&
                <Spinner
                  margin='30px auto'
                  className={AppUI.siteIsSeedlang ? 'blue' : null}
                  background={AppUI.siteIsSeedlang || isBlank(AppUI.site.accentColor) ? Theme.blue : AppUI.site.accentColor}
                />
            }
            {
              AppUI.notificationStore.hasIndexData &&
                AppUI.siteIsSeedlang ? (
                  <NotificationIndex
                    notifications={AppUI.notificationStore.indexData}
                    store={AppUI.notificationStore}
                  />
                ) : (
                  <NotificationIndexMemrev
                    notifications={AppUI.notificationStore.indexData}
                    store={AppUI.notificationStore}
                  />
                )
            }
          </ScrollContainer>
        </HeaderPopup>
      </Wrapper>
    );
  }
}

export default NotificationsWithPopup;
